import React from 'react';
import DatePicker, {registerLocale} from "react-datepicker";
import ru from 'date-fns/locale/ru';
registerLocale('ru', ru)

const RangeDate = ({startDate, onChange, endDate}) => {
    return (
        <div className={'m-auto flex justify-center mt-8'}>
            <DatePicker
                selected={startDate}
                onChange={onChange}
                startDate={startDate}
                endDate={endDate}
                selectsRange
                inline
                locale={'ru'}
            />
        </div>
    );
};

export default RangeDate;